import React from 'react';
import { Box, Container, Grid, Typography, Link, Button } from '@mui/material';
import { Facebook, Instagram, LinkedIn, YouTube } from '@mui/icons-material';
import { FaTiktok } from 'react-icons/fa';

const Footer = () => {
  const quickLinks = [
    { name: 'About USC', url: 'https://usc.edu.tt/about-us/we-are-usc/' },
    { name: 'Contact us', url: 'https://usc.edu.tt/about-us/contact-us/' },
    { name: 'Forde Library', url: 'https://library.usc.edu.tt' },
    { name: 'University Calendars', url: 'https://calendar.usc.edu.tt' }
  ];

  const socialLinks = [
    { icon: <Facebook />, url: 'https://www.facebook.com/usctt/' },
    { icon: <FaTiktok size={20} />, url: 'https://www.tiktok.com/@usccaribbean' },
    { icon: <YouTube />, url: 'https://www.youtube.com/c/universityofthesoutherncaribbean' },
    { icon: <Instagram />, url: 'https://www.instagram.com/usctt/' },
    { icon: <LinkedIn />, url: 'https://www.linkedin.com/school/usctt/' }
  ];

  return (
    <Box component="footer" sx={{ mt: 'auto' }}>
      {/* Main Footer Section */}
      <Box sx={{ backgroundColor: '#4A4A4A', py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} sx={{ position: 'relative' }}>
            {/* Column 1 - USC Info (wider) */}
            <Grid item xs={12} md={3.5}>
              <Box sx={{ pr: 2 }}>
                <Box
                  component="img"
                  src="/usc-footer-brand.png"
                  alt="University of the Southern Caribbean"
                  sx={{ maxWidth: '100%', height: 'auto', mb: 1 }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: 'white',
                    fontSize: '0.85rem',
                    lineHeight: 1.5,
                    opacity: 0.9,
                    fontFamily: '"Roboto", sans-serif'
                  }}
                >
                  The University of the Southern Caribbean offers holistic education,
                  preparing students for service to God and humanity.
                </Typography>
              </Box>
            </Grid>

            {/* Vertical Divider 1 */}
            <Box
              sx={{
                position: 'absolute',
                left: 'calc(29.17% - 1px)',
                top: 20,
                bottom: 20,
                width: '2px',
                backgroundColor: '#FCCA18',
                display: { xs: 'none', md: 'block' }
              }}
            />

            {/* Column 2 - Address */}
            <Grid item xs={12} md={2.5}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  mb: 1.5,
                  fontSize: '1.2rem',
                  fontFamily: '"Roboto", sans-serif'
                }}
              >
                Address
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: 'white',
                  fontSize: '0.8rem',
                  lineHeight: 1.4,
                  opacity: 0.9,
                  fontFamily: '"Roboto", sans-serif'
                }}
              >
                Maracas Royal Road,<br />
                St. Joseph, Trinidad.<br />
                Tel: +1 868-662-2241<br />
                E-Mail: info@usc.edu.tt
              </Typography>
            </Grid>

            {/* Vertical Divider 2 */}
            <Box
              sx={{
                position: 'absolute',
                left: '50%',
                top: 20,
                bottom: 20,
                width: '2px',
                backgroundColor: '#FCCA18',
                display: { xs: 'none', md: 'block' }
              }}
            />

            {/* Column 3 - Quick Links */}
            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  mb: 1.5,
                  fontSize: '1.2rem',
                  fontFamily: '"Roboto", sans-serif'
                }}
              >
                Quick Links
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                {quickLinks.map((link, index) => (
                  <Box component="li" key={index} sx={{ mb: 0.5 }}>
                    <Link
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: 'white',
                        textDecoration: 'none',
                        fontSize: '0.8rem',
                        opacity: 0.9,
                        fontFamily: '"Roboto", sans-serif',
                        '&:hover': {
                          color: '#FCCA18',
                          opacity: 1
                        }
                      }}
                    >
                      {link.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>

            {/* Vertical Divider 3 */}
            <Box
              sx={{
                position: 'absolute',
                left: '75%',
                top: 20,
                bottom: 20,
                width: '2px',
                backgroundColor: '#FCCA18',
                display: { xs: 'none', md: 'block' }
              }}
            />

            {/* Column 4 - Follow Us */}
            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  mb: 1.5,
                  fontSize: '1.2rem',
                  fontFamily: '"Roboto", sans-serif'
                }}
              >
                Follow Us
              </Typography>

              {/* WhatsApp Channel Button */}
              <Button
                href="https://whatsapp.com/channel/0029VbBJ9Bs1CYoRXBGZzn1y"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#FCCA18',
                  color: '#2E2E2E',
                  fontWeight: 600,
                  fontSize: '0.7rem',
                  px: 2,
                  py: 0.5,
                  mb: 1.5,
                  fontFamily: '"Roboto", sans-serif',
                  '&:hover': {
                    backgroundColor: '#E6B515'
                  }
                }}
              >
                JOIN OUR CHANNEL »
              </Button>

              {/* Social Media Icons */}
              <Box sx={{ display: 'flex', gap: 1 }}>
                {socialLinks.map((social, index) => (
                  <Link
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 40,
                      height: 40,
                      backgroundColor: 'transparent',
                      color: 'white',
                      borderRadius: '50%',
                      border: '2px solid white',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#FCCA18',
                        borderColor: '#FCCA18',
                        color: '#2E2E2E',
                        transform: 'translateY(-2px)'
                      }
                    }}
                  >
                    {social.icon}
                  </Link>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Bottom Copyright Section */}
      <Box sx={{ backgroundColor: '#1A1A1A', py: 2, borderTop: '1px solid #333' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 1 }}>
            <Link href="/sitemap" sx={{ color: 'white', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: '#FCCA18' } }}>
              USC Sitemap
            </Link>
            <Typography component="span" sx={{ color: 'white', mx: 1, fontSize: '0.75rem' }}>|</Typography>
            <Link href="/privacy" sx={{ color: 'white', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: '#FCCA18' } }}>
              Site Use and Privacy
            </Link>
            <Typography component="span" sx={{ color: 'white', mx: 1, fontSize: '0.75rem' }}>|</Typography>
            <Link href="/feedback" sx={{ color: 'white', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: '#FCCA18' } }}>
              Feedback
            </Link>
          </Box>

          <Typography variant="body2" sx={{ color: 'white', fontSize: '0.75rem', textAlign: 'center', mb: 0.3 }}>
            Copyright © 2025 University of the Southern Caribbean.
          </Typography>
          <Typography variant="body2" sx={{ color: 'white', fontSize: '0.75rem', textAlign: 'center' }}>
            A Seventh-day Adventist institution of higher education. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;